<template>
    <div class="index">
        <div class="top">
            <el-steps :active="humanStatusActive" simple finish-status="process" process-status="finish" style="width:1400px">
                <!-- <el-step title="新案件" :icon="stepsActive>0?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="待派工" :icon="stepsActive>1?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="作业中" :icon="stepsActive>2?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="待审核" :icon="stepsActive>3?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="已结案" :icon="stepsActive>4?'el-icon-folder-checked':'el-icon-edit'"></el-step> -->

                <el-step title="新任务" :icon="humanStatusActive>0?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="查勘中" :icon="humanStatusActive>1?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="查勘审核" :icon="humanStatusActive>2?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="查勘退回" :icon="humanStatusActive>3?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="人伤跟踪" :icon="humanStatusActive>4?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="方案制作中" :icon="humanStatusActive>5?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="方案审核" :icon="humanStatusActive>6?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="审核退回" :icon="humanStatusActive>7?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="协议签署中" :icon="humanStatusActive>8?'el-icon-folder-checked':'el-icon-edit'"></el-step>
                <el-step title="任务完成" :icon="humanStatusActive>9?'el-icon-folder-checked':'el-icon-edit'"></el-step>
            </el-steps>
        </div>
        <div class="index-item">
            <div class="title">
                案件信息
            </div>
            <div class="content">
                
                <div class="citem">
                    <div class="label">
                        委托主体
                    </div>
                    <el-input v-model="detailData.wtzt" placeholder="请输入" size="small" class="citem-input"></el-input>
                </div>

                <div class="citem">
                    <div class="label">
                        报案号
                    </div>
                    <el-input v-model="detailData.caseNo" placeholder="请输入" size="small" class="citem-input"></el-input>
                </div>

                <div class="citem">
                    <div class="label">
                        案件类型
                    </div>
                    <el-input v-model="detailData.caseTypeStr" placeholder="请输入" size="small" class="citem-input"></el-input>
                </div>
                
                <div class="citem">
                    <div class="label">
                        案发地区
                    </div>
                    <el-cascader
                        size="small"
                        :options="options"
                        v-model="crimeCityCode"
                        @change="handleRegionChange">
                    </el-cascader>
                    <!-- <el-input v-model="detailData.zhengJianNo" placeholder="请输入" size="small" class="citem-input"></el-input> -->
                </div>
                <div class="citem">
                    <div class="label">
                        案发地点
                    </div>
                    <el-input v-model="detailData.address" placeholder="请输入" size="small" class="citem-input"></el-input>
                </div>

                <div class="citem">
                    <div class="label">
                        联系人
                    </div>
                    <el-input v-model="detailData.contacts" placeholder="" size="small" class="citem-input"></el-input>
                </div>
                <div class="citem">
                    <div class="label">
                        联系人电话
                    </div>
                    <el-input v-model="detailData.contactsPhone" placeholder="" size="small" class="citem-input"></el-input>
                </div>
                <div class="citem">
                    <div class="label">
                        联系人地址
                    </div>
                    <el-input v-model="detailData.contactsAddress" placeholder="" size="small" class="citem-input"></el-input>
                </div>


                <div class="citem">
                    <div class="label">
                        标的责任
                    </div>
                    <el-input v-model="detailData.targetLand" placeholder="请输入" size="small" class="citem-input"></el-input>
                    
                </div>
                <div class="citem">
                    <div class="label">
                        标准公估费
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.fee" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                </div>

                <div class="citem">
                    <div class="label">
                        实收公估费
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.ssFee" placeholder="请输入" size="small" class="citem-input"></el-input>
                    </div>
                </div>
                <div class="citem">
                    <div class="label">
                        总作业费
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.operatorFees" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                    </div>
                </div>
                
                <div class="citem">
                    <div class="label">
                        车牌号
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.carNo" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                    </div>
                </div>
                <div class="citem">
                    <div class="label">
                        车险查勘员
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.survey" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                    </div>
                </div>
                <div class="citem">
                    <div class="label">
                        查勘员手机号
                    </div>
                    <div class="citem-value">
                        <el-input v-model="detailData.surveyPhone" placeholder="请输入" size="small" class="citem-input" disabled></el-input>
                    </div>
                </div>
                <div class="citem citem-textarea" style="width:100%">
                    <div class="label">
                        案件备注:
                    </div>
                    <div class="value" style="width:778px">{{detailData.remark?detailData.remark:'暂无'}}</div>
                    
                    <!-- <el-input v-model="detailData.remark" placeholder="请输入" size="small" class="citem-input" rows="4" type="textarea" style="width:778px"></el-input> -->
                </div>
            </div>
        </div>
        <el-form :model="humanData" ref="rulesForm" label-width="120px">
         <!-- @tab-click="tabSelect" -->
            <el-tabs type="border-card" class="card" v-model="tabsValue">
                <el-tab-pane>
                    <span slot="label"><i class="el-icon-date"></i> 伤者信息</span>
                    <div class="content">
                        <div class="citem">
                            <div class="label">
                                <span>*</span>
                                伤者姓名
                            </div>
                            <el-input v-model="humanData.name" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                        <div class="citem">
                            <div class="label">
                                <span>*</span>
                                联系电话
                            </div>
                            <el-input v-model="humanData.phone" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                        <div class="citem">
                            <div class="label">
                                联系地址
                            </div>
                            <el-input v-model="humanData.contactAddress" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                        <div class="citem">
                            <div class="label">
                                证件类型
                            </div>
                            <el-input v-model="humanData.idType" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                        <div class="citem">
                            <div class="label">
                                证件号码
                            </div>
                            <el-input v-model="humanData.idNumber" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                        <div class="citem">
                            <div class="label">
                                归属车辆
                            </div>
                            <el-input v-model="humanData.guiShuCar" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>

                        <div class="citem">
                            <div class="label">
                                伤者身份
                            </div>
                            <el-input v-model="humanData.humanShenFen" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                        <div class="citem">
                            <div class="label">
                                伤者类型
                            </div>
                            <el-input v-model="humanData.humanType" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                        <div class="citem">
                            <div class="label">
                                职业类型
                            </div>
                            <el-input v-model="humanData.zhiYeType" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                        <div class="citem">
                            <div class="label">
                                所在行业
                            </div>
                            <el-input v-model="humanData.hangYe" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                        <div class="citem">
                            <div class="label">
                                收入(元/日)
                            </div>
                            <el-input v-model="humanData.shouRu" placeholder="请输入" size="small" class="citem-input" type="number"></el-input>
                        </div>
                        <div class="citem">
                            <div class="label">
                                工作单位
                            </div>
                            <el-input v-model="humanData.danWei" placeholder="请输入" size="small" class="citem-input"></el-input>
                        </div>
                        <div class="citem">
                            <div class="label">
                                <el-checkbox v-model="isFinish">查勘已完成</el-checkbox>
                            </div>
                        </div>
                        <div class="citem" style="width:100%">
                            <div class="label">
                                派工备注
                            </div>
                            <el-input v-model="humanData.remark" placeholder="请输入" size="small" class="citem-input" type="textarea" style="width:500px"></el-input>
                        </div>
                        <div class="citem citem-textarea" style="width:780px">
                            <div class="label">
                                查勘备注:
                            </div>
                            <el-input v-model="detailData.tip" placeholder="" size="small" class="citem-input" rows="5" type="textarea" style="width:643px" disabled></el-input>
                        </div>

                        <div class="citem citem-textarea" style="width:780px">
                            <div class="label">
                                未决备注:
                            </div>
                            <el-input v-model="detailData.wjtip" placeholder="" size="small" class="citem-input" rows="5" type="textarea" style="width:643px" disabled></el-input>
                        </div>

                        <div class="citem">
                            <div class="label">
                                <span>*</span>
                                指派查勘员:
                            </div>
                            <div class="value">
                                <el-select v-model="humanData.operatorId" size="small" placeholder="请选择"  class="citem-input" @change="changeOperatorId" filterable>
                                    <el-option
                                    v-for="item in personList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="citem">
                            <div class="label">
                                <span>*</span>
                                作业费:
                            </div>
                            <div class="value">
                                <el-input v-model="humanData.operatorFee" placeholder="请输入" size="small" class="citem-input" type="number"></el-input>
                            </div>
                        </div>
                        <div class="citem" style="width:100%">
                            <div class="label">
                                查勘需求:
                            </div>
                            <div class="value">
                                <el-input v-model="humanData.dcYq" placeholder="请输入" size="small" class="citem-input" type="textarea" style="width:500px"></el-input>
                            </div>
                        </div>

                        
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-form>


        

        <div class="bottom">
            <el-button type="primary" icon="el-icon-edit" @click="submitCase()">保存</el-button>
        </div>

        

        <!-- 大图预览 -->
        <el-image-viewer
            v-if="showBigImg"
            :on-close="closeViewer"
            :url-list="showBigImgList"
            :initial-index="imgIndex"
        />
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeD} from '../../../utils/index'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import { regionDataPlus , provinceAndCityData , CodeToText , TextToCode } from "element-china-area-data";
import {CaseTypeList } from '../../../assets/selectList/index'

export default {
    name: 'index',
    components:{
        ElImageViewer
    },
    watch: {
    },
    data () {
        return {
            
            caseTypeList:CaseTypeList,
            detailData:{
                
            },
            humanData:{
                "piccHumanTaskId": null,
                "piccHumanId": null,
                "name": "",
                "phone": "",
                "contactAddress": "",
                "idType": "",
                "idNumber": "",
                "humanType": "",
                "humanShenFen": "",
                "zhiYeType": "",
                "hangYe": "",
                "shouRu": 0,
                "danWei": "",
                "guiShuCar": "",
                "dianFuFee": 0,
                "dispatchId": null,
                "tjReturnReason": "",
                "dcReturnReason": ""
            },

            options:provinceAndCityData,
            crimeCityCode:[],
            uploadUrl:'',

           


            showBigImg:false,
            showBigImgList:[],
            imgIndex:0,

            allNum:0,
            finishNum:0,

            stepsActive:'',
            tabsValue:'0',

            materialList:[],
            hospitalList:[],
            diagnoseList:[],

            crimeCityCode:[],

            humanStatusActive:this.$route.query.humanStatusActive,
            personList:[],


            isFinish:false,
            
        }
    },
    watch:{
        'tabsValue':function(n,o){
            if(o==0){
                if(this.humanData.id){
                    this.updateHuman();
                }else{
                    this.addHuman();
                }
            }else if(o==1){
                this.saveDcTaskMaterials();
            }
        }
    },
    created(){
        

    },
    mounted(){
        this.getDetailData();
        this.queryUserByMechanismIds();
    },
    methods:{
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        handleRegionChange(codeArray){
            if(codeArray[0]){
                this.detailData.province = CodeToText[codeArray[0]]
            }
            if(codeArray[1]){
                this.detailData.city = CodeToText[codeArray[1]]
            }
        },

        // 查询机构人员
        async queryUserByMechanismIds(){
            let res = await api.queryUserByMechanismIds({
                pageSize:1000,
            });
            this.personList = res.data.data;
            console.log(this.personList);
        },
        // 修改操作人Id
        async changeOperatorId(e){
            for(let index in this.personList){
                if(this.personList[index].id==e){
                    this.humanData.operator =  this.personList[index].name;
                }
            }
        },
        // 新增伤者信息
        async addHuman(){
            this.humanData.piccHumanId = this.$route.query.id;
            this.humanData.piccHumanTaskId = this.$route.query.taskId;
            this.humanData.shouRu = parseFloat(this.humanData.shouRu?this.humanData.shouRu:0);
            let res = await api.addHuman({humans:[this.humanData]});
            // this.humanData.id = res.data.data.humanId
            if(res.data.code=='200'){
                if(this.isFinish){
                    this.updateHumanStatus(res.data.data.humanId,40);
                }else{
                    this.assignHuman(res.data.data.humanId);
                }
            }
        },
        async assignHuman(id){
            console.log(this.humanData);
            let res = await api.assignHuman({
                "piccHumanTaskId": this.$route.query.taskId,
                "piccHumanId": this.$route.query.id,
                "humanId": id,
                "operatorId": this.humanData.operatorId,
                "operator": this.humanData.operator,
                "dcYq": this.humanData.dcYq,
                "operatorFee":parseFloat(this.humanData.operatorFee),
            });
            if(res.data.code=='200'){
                if(this.isFinish){
                    this.updateHumanStatus(id,40);
                }else{
                    this.$message({
                        type: 'success',
                        message: '新增完成！'
                    }); 
                    this.$router.go(-1)
                }
                
            }
        },
        // 更新伤者状态
        async updateHumanStatus(id,status){
            let res = await api.updateHumanStatus({
                "humanId": id,
                "dcReturnReason": "",
                "humanStatus": status,
            });
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '新增完成！'
                });  
                // this.$router.go(-1);
                this.$router.go(-1)
            }
        },
        // 更新伤者信息
        async updateHuman(){
            this.humanData.piccHumanId = this.$route.query.id;
            this.humanData.piccHumanTaskId = this.$route.query.taskId;
            this.humanData.shouRu = parseFloat(this.humanData.shouRu?this.humanData.shouRu:0);
            let res = await api.updateHuman({humans:[this.humanData]});
            return true;
        },
        

        // 保存查勘資料
        async saveDcTaskMaterials(){
            for(let index in this.materialList){
                this.materialList[index].sort = parseFloat(index);
            }
            let res = await api.addDcTaskMaterials({dcTaskMaterials:this.materialList});
        },
        
       
        
        // 查看详情
        async getDetailData(){
            let res = await api.piccHumanQueryByPiccHumanId(this.$route.query.id);
            this.detailData = res.data.data;
            this.detailData.caseTypeStr = this.detailData.caseType==1?'全流程':'首勘';
            if(TextToCode[this.detailData.province]&&TextToCode[this.detailData.province][this.detailData.city]){
                this.crimeCityCode = [TextToCode[this.detailData.province].code,TextToCode[this.detailData.province][this.detailData.city].code];
            }
            if(this.detailData.piccHumanStatus == 0){
                this.stepsActive = 0;
            }else if(this.detailData.piccHumanStatus == 10){
                this.stepsActive = 1;
            }else if(this.detailData.piccHumanStatus == 20){
                this.stepsActive = 2;
            }else if(this.detailData.piccHumanStatus == 30){
                this.stepsActive = 3;
            }else if(this.detailData.piccHumanStatus == 40){
                this.stepsActive = 4;
            }
        },
     
        // tab切换
        // async tabSelect(e){
        //     console.log(e.index);
        //     if(e.index== 0){
        //     }else if(e.index==1){
                
        //     }else if(e.index==2){
        //     }else if(e.index==3){
        //     }else if(e.index==4){
        //     }
        // },
        submitCase(){
            
            
            if(!this.humanData.name){
                this.$message({
                    type: 'error',
                    message: '伤者姓名未填'
                });
                return;
            }
            if(!this.humanData.phone){
                this.$message({
                    type: 'error',
                    message: '联系电话未填'
                });
                return;
            }
            // if(!this.isFinish){
            //     if(!this.humanData.operatorId){
            //         this.$message({
            //             type: 'error',
            //             message: '未指派查勘员'
            //         });
            //         return;
            //     }
            //     if(!this.humanData.operatorFee){
            //         this.$message({
            //             type: 'error',
            //             message: '作业费未填'
            //         });
            //         return;
            //     }
            // }
            

            
            if(this.tabsValue== 0){
                if(this.humanData.id){
                    this.updateHuman();
                }else{
                    this.addHuman();

                }
            }else if(this.tabsValue==1){
                this.saveDcTaskMaterials();
            }else if(this.tabsValue==2){
            }else if(this.tabsValue==3){
            }else if(this.tabsValue==4){
            }
        },

        
        // 上传
        async materialUpload(file){
            let material = {
                piccHumanId:this.$route.query.id,
                fileType:'',
                name:'',
                path:'',
            };
            material.name = file.file.name;
            let fileTypeList = material.name.split('.');
            let fileType = fileTypeList[fileTypeList.length-1];
            material.fileType = fileType;
            let res = await api.uploadOther(file.file);
            material.path = res;
            if(this.materialList){
                this.materialList.push(material);
            }else{
                this.materialList=[material];
            }
        },
        // 删除资料
        clearMaterialList(index){
            this.materialList.splice(index,1)
        },
        download(path,name){
            this.$message({
                type: 'success',
                message: '下载成功,请稍等!'
            });
            const elt = document.createElement('a');
            elt.setAttribute('target', '_blank');
            elt.setAttribute('href', path);
            elt.setAttribute('download', name);
            elt.style.display = 'none';
            document.body.appendChild(elt);
            elt.click();
        },

        // 查询影像资料
        async queryDcTaskMaterialByPiccHumanId(){
            let res = await api.queryDcTaskMaterialByPiccHumanId(this.$route.query.id);
            this.materialList = res.data.data;
        },
        // 查询医院
        async queryHospitalByHumanId(){
            let res = await api.queryHospitalByHumanId(this.$route.query.id);
            this.hospitalList = res.data.data;
        },
        // 查询诊断信息
        async queryHospitalByHumanId(){
            let res = await api.queryHospitalByHumanId(this.$route.query.id);
            this.hospitalList = res.data.data;
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .top{
        height: 40px;
        display: flex;
        justify-content: space-between;
        padding:10px;
        background-color: #ffffff;
        z-index: 60;
        /deep/.el-step__title{
           font-weight: bold; 
        }
        /deep/.el-steps--simple{
            padding: 13px 0px;
        }
    }
    .index{
        .index-item{
            border: 1px solid #eee;
            box-shadow: 0 1px 4px rgbe(0,21,41,8%);
            display: flex;
            flex-wrap: wrap;
            padding:2px 15px;
            padding-top: 20px;
            margin-bottom: 10px;
            .title{
                width: 100%;
                font-weight: bold;
                font-size: 18px;
                margin-bottom: 20px;
            }
            .content{
                min-width: 900px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                .checkbox{
                    margin-right: 40px;
                    margin-bottom: 10px;
                    /deep/.el-checkbox__label{
                        font-size: 14px;
                        color: #000000;
                    }
                }
                .citem{
                    display: flex;
                    align-items: center;
                    margin-right: 25px;
                    padding-bottom: 20px;
                    width: 380px;
                    .label{
                        width: 100px;
                        
                    }
                    .value{
                        border: 1px solid #DCDFE6;
                        border-radius: 4px;
                        font-size: 14px;
                        color: #606266;
                        line-height: 24px;
                        padding: 5px 10px;
                    }
                    .citem-input{
                        width: 250px;
                    }
                    /deep/.el-tag--medium{
                        height: 42px;
                        line-height: 42px;
                        margin-right: 10px;
                    }
                }
            }
            
        }
        .card{
            .content{
                min-width: 900px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                .checkbox{
                    margin-right: 40px;
                    margin-bottom: 10px;
                    /deep/.el-checkbox__label{
                        font-size: 14px;
                        color: #000000;
                    }
                }
                .citem{
                    display: flex;
                    align-items: center;
                    margin-right: 25px;
                    padding-bottom: 20px;
                    width: 380px;
                    .label{
                        width: 100px;
                        span{
                            color:red;
                            font-size: 18px;
                        }
                    }
                    .citem-input{
                        width: 250px;
                    }
                    /deep/.el-tag--medium{
                        height: 42px;
                        line-height: 42px;
                        margin-right: 10px;
                    }
                }
                .citem-textarea{
                    width: 100%;
                    .label{
                        width: 150px;
                    }
                    .citem-input{
                        width: 750px;
                    }
                }
            }

            .materiallist{
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 15px;
                align-items: center;
                .material{
                    border: 1px dashed #dcdcdc;
                    width: 150px;
                    padding-top: 15px;
                    padding-bottom: 6px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    border-radius: 4px;
                    margin:10px;
                    position: relative;
                    float: left;
                    span{
                        display: flex;
                        flex-wrap: wrap;
                    }
                    img{
                        width: 120px;
                    }
                    .close{
                        width: 25px;
                        height: 25px;
                        position: absolute;
                        right: 3px;
                        top: 3px;
                    }
                    .filename{
                        width: 130px;
                        font-size: 12px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        text-align: center;
                        margin-top: 2px;
                    }
                    .el-button--mini, .el-button--mini.is-round{
                        padding-bottom: 0px;
                        padding-top: 4px;
                    }
                }
            }
            .btns{
                margin-bottom: 15px;
            }
        }
        .bottom{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: 20px;
        }


        .dialog{
            padding-top: 20px;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            .item{
                
                font-size: 14px;
                padding:10px 150px;
                display: flex;
                align-items: center;
                justify-content: center;
                .label{
                    min-width: 110px;
                    margin-bottom: 5px;
                }
                .item-input{
                    width: 340px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    /deep/.el-input{
                        width: 320px;
                    }
                }
                .item-imgs{
                    width: 380px;
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 10px;
                    .item-img{
                        position: relative;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        .icon{
                            right: 0;
                            top: 0;
                            position:absolute;
                            z-index: 100;
                            color: #ffffff;
                            background-color: #000000;
                            width: 18px;
                            height: 18px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;
                        }

                    }
                }
                /deep/.el-image{
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
                .item-textarea{
                    width: 380px;
                }
            }


            
            .dialog-footer{
                width: 100%;
                display: flex;
                justify-content: center;
                .el-button{
                    margin-top: 20px;
                }
            }
            
        }
        .dialog-t{
            padding-top: 20px;
            height: 100%;
            display: flex;
            flex-wrap: wrap;
            .item{
                
                font-size: 14px;
                padding:10px 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                .label{
                    min-width: 110px;
                    margin-bottom: 5px;
                }
                .item-input{
                    width: 340px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    /deep/.el-input{
                        width: 320px;
                    }
                }
                .item-imgs{
                    width: 380px;
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 10px;
                    .item-img{
                        position: relative;
                        margin-right: 10px;
                        margin-bottom: 10px;
                        .icon{
                            right: 0;
                            top: 0;
                            position:absolute;
                            z-index: 100;
                            color: #ffffff;
                            background-color: #000000;
                            width: 18px;
                            height: 18px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;
                        }

                    }
                }
                /deep/.el-image{
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
                .item-textarea{
                    width: 380px;
                }
            }
            .section{
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                border: 1px solid #DEDEDE;
                margin-bottom: 15px;
                padding-bottom: 10px;
                .title{
                    width: 100%;
                    font-weight: bold;
                    font-size: 16px;
                    margin-bottom: 12px;
                    background-color: #DEDEDE;
                    padding:8px 15px;
                }
                .materiallist{
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    margin-bottom: 15px;
                    padding: 15px;
                    .material{
                        border: 1px dashed #dcdcdc;
                        width: 150px;
                        height: 170px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        border-radius: 4px;
                        margin:10px;
                        position: relative;
                        img{
                            width: 120px;
                        }
                        .close{
                            width: 25px;
                            height: 25px;
                            position: absolute;
                            right: 3px;
                            top: 3px;
                        }
                        .filename{
                            width: 130px;
                            font-size: 12px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            text-align: center;
                            margin-top: 2px;
                        }
                    }
                }
            }
            
            .dialog-footer{
                width: 100%;
                display: flex;
                justify-content: center;
                .el-button{
                    margin-top: 20px;
                }
            }
        }
    }

    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding-bottom: 15px;
        
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            width: 300px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    /deep/.el-step.is-simple .el-step__title{
        font-size: 15px;
    } 
    /deep/.el-step.is-simple:not(:last-of-type) .el-step__title{
        max-width: 70%;
    } 
    /deep/.el-steps--simple{
        padding:  0px;
        background-color: #ffffff;
    }
    /deep/.el-steps{
        width: 1000px;
    }
    /deep/.el-step.is-simple .el-step__arrow::after, /deep/.el-step.is-simple .el-step__arrow::before{
        height: 9px !important;
    }
    
    /deep/.el-step.is-simple .el-step__arrow::after{
        transform: rotate(45deg) translateY(3px);
    }
    /deep/.el-step.is-simple .el-step__arrow::before{
        transform: rotate(-45deg) translateY(-3px);
    }
    /deep/.el-input.is-disabled .el-input__inner{
        color:#606266;
    }
</style>
